import * as React from 'react';
/**
 *
 * Original name: remove text formatting
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=33089%3A9703
 *
 */
export const RemoveTextFormattingLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.25 11.69-6.87 6.868 1.062 1.061L19.619 5.442 18.56 4.38 17.44 5.5H6.5V7h4.75v4.688Zm1.5-1.5L15.938 7H12.75v3.188Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M11.25 18.5v-2.568l1.5-1.5V18.5h-1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
